import { useEffect, useState } from "react";
import { userService } from "../../../_services";
import moment from "moment-timezone";
import { useTranslation } from "react-i18next";
import "./DailyReportFinal.css";
import { Clock, User, Phone, Award, Star, XCircle } from "lucide-react";

export default function DailyReportFinal() {
    const { t } = useTranslation();
    let user = localStorage.getItem("user");
    user = JSON.parse(user);

    const [todayHistory, setTodayHistory] = useState();

    useEffect(() => {
        const fetch = async () => {
            setTodayHistory(await userService.getHistory({ prevDays: 1 }));
        }
        fetch();
    }, []);

    const undoOnclick = async (id, type) => {
        const result = await userService.undoTransaction(type, id);
    };

    const getActionTypeStyles = (type) => {
        switch (type?.toLowerCase()) {
            case "usage":
                return "bg-blue-50 text-blue-700 border-blue-200";
            case "purchased":
                return "bg-green-50 text-green-700 border-green-200";
            case "canceled":
                return "bg-amber-50 text-amber-700 border-amber-200";
            default:
                return "bg-gray-50 text-gray-700 border-gray-200";
        }
    };

    return (
        <div className="daily-report-container">
            {todayHistory?.length === 0 &&
                <h2 className="no-history-message">{t('noHistoryFound')}</h2>
            }

            {todayHistory?.length > 0 && todayHistory.map((o, index) => {
                const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                const currentTime = moment(o.createDate).tz(timezone).format();
                let datetime = currentTime.slice(0, 19).replace('T', ' ');
                datetime = datetime.split(" ");
                let d = datetime[0];
                let hours = datetime[1];

                return (
                    <div className="report-card" key={index}>
                        {o.objectType === "canceled" &&
                            <div className="canceled-banner">
                                <h2>{t('actionCancelled')}</h2>
                            </div>
                        }

                        <div className="report-header">
                            <div className="report-date">
                                <Clock size={25} />
                                <span>
                                    <span>{d}</span>
                                    <span>|</span>
                                    <span>{hours}</span>
                                </span>
                            </div>
                            {o.objectType !== "canceled" && (
                                <div className={`report-action-type ${getActionTypeStyles(o.objectType)}`}>
                                    {o.objectType}
                                </div>
                            )}
                        </div>

                        <div className="report-content">
                            <h3 className="report-title">
                                {o.objectType !== "canceled" ? o?.offerDescription : o?.benefitOffer?.description}
                            </h3>
                        </div>

                        <div className="points-section">
                            <div className="points-item">
                                <div className="points-icon bg-amber-100">
                                    <Award size={20} className="text-amber-600" />
                                </div>
                                <div>
                                    <div className="points-label">{t('pointsReduced')}</div>
                                    <div className="points-value">{o?.pointsReduced}</div>
                                </div>
                            </div>

                            {(o.objectType === "purchased" || o.objectType === "usage") && (
                                <div className="points-item">
                                    <div className="points-icon bg-purple-100">
                                        <Star size={20} className="text-purple-600" />
                                    </div>
                                    <div>
                                        <div className="points-label">{t('pointsLeft')}</div>
                                        <div className="points-value">
                                            {o.objectType === "purchased"
                                                ? o?.pointsPurchased - o?.pointsReduced
                                                : o?.pointsStatus}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="customer-info">
                            <div className="info-row">
                                <User size={18} />
                                <label>{t('customerName')}</label>
                                <span>{o?.customer?.firstName + " " + o?.customer?.lastName}</span>
                            </div>
                            <div className="info-row">
                                <Phone size={18} />
                                <label>{t('phoneNumber')}</label>
                                <span>{o?.customer?.phoneNo}</span>
                            </div>
                        </div>

                        {(index === 0 && o.objectType !== "canceled" && user.business_id === o?.businessId) && (
                            <div className="undo-button-container">
                                <button
                                    onClick={() => undoOnclick(o?.id, o?.objectType)}
                                    className="undo-button"
                                >
                                    <XCircle size={20} />
                                    {t('undoAction')}
                                </button>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
